/** @format */

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { signOut, toggleMobileNav } from "../redux/slices/userSlice";
import { Link } from "react-router-dom";

const Header = ({ loggedin }) => {
  const dispatch = useDispatch();

  const handleSignOut = () => {
    dispatch(signOut());
  };

  const mobileNavActive = useSelector((state) => state.user.isMobileNavActive);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  const handleToggleMobileNav = () => {
    dispatch(toggleMobileNav());
  };

  if (!loggedin) {
    return <div></div>;
  }

  return (
    <header
      id='header'
      className='header d-flex align-items-center sticky-top'
    >
      <div className='container position-relative d-flex align-items-center justify-content-between'>
        <a
          href='index.html'
          className='logo d-flex align-items-center me-auto me-xl-0'
        >
          <img
            src='https://fundacionunam.org/cei/assets/img/logo.png'
            alt=''
          />
        </a>

        <nav
          id='navmenu'
          className={`navmenu ${mobileNavActive ? "mobile-nav-active" : ""}`}
        >
          <ul>
            <li>
              <Link
                className='nav-link'
                to='solidarios'
                onClick={handleToggleMobileNav}
              >
                Solidarios
              </Link>
            </li>
            <li>
              <Link
                className='nav-link'
                to='contenidos'
                onClick={handleToggleMobileNav}
              >
                Contenidos
              </Link>
            </li>
            <li>
              <Link
                className='nav-link'
                to='datos'
                onClick={handleToggleMobileNav}
              >
                Datos personales
              </Link>
            </li>
            <li>
              <Link
                className='nav-link'
                to='foro'
                onClick={handleToggleMobileNav}
              >
                Foro
              </Link>
            </li>
            <li>
              <Link
                className='nav-link'
                to='cursos'
                onClick={handleToggleMobileNav}
              >
                Cursos
              </Link>
            </li>
            <li>
              <div className='container-fluid'>
                <form
                  className='d-flex'
                  method='GET'
                  action='https://www.fundacionunam.org.mx/'
                >
                  <button
                    title='Cerrar sesión'
                    className='btn btn-danger mx-1'
                    onClick={handleSignOut}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='25'
                      height='25'
                      fill='currentColor'
                      className='bi bi-box-arrow-right'
                      viewBox='0 0 16 16'
                    >
                      <path
                        fillRule='evenodd'
                        d='M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z'
                      />
                      <path
                        fillRule='evenodd'
                        d='M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z'
                      />
                    </svg>
                  </button>
                </form>
              </div>
            </li>
          </ul>
          <i
            className={`mobile-nav-toggle d-xl-none bi ${
              mobileNavActive ? "bi-x" : "bi-list"
            }`}
            onClick={handleToggleMobileNav}
          ></i>
        </nav>
      </div>
    </header>
  );
};

export default Header;
